import React from "react";

export default function EntryRequirementDetails({
  title,
  desc,
  grade,
  details,
  interview,
}) {
  return (
    <div className="p-2 w-72 flex flex-col gap-2">
      <div className="font-semibold">
        {title}: Minimum {grade}
      </div>
      <div>{details}</div>
      {/* <ul className="list-disc list-inside pl-4">
        {desc.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul> */}
      {interview === "Yes" && (
        <div>All eligible candidates are required to attend an interview. </div>
      )}
    </div>
  );
}
